import { createFileRoute } from '@tanstack/react-router';
import { MySopsPage } from '@/features/sops/pages/my-sops-page';

export const Route = createFileRoute('/_app/me/sops')({ component: MySopsPage });
